import { Component, computed, input } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import {
  faCircleInfo,
  faCheck,
  faXmark,
  faTriangleExclamation,
} from '@fortawesome/free-solid-svg-icons';

type AlertType = 'info' | 'success' | 'error' | 'warning';

@Component({
  selector: 'app-dashboard-alert',
  template: `
    <div
      class="text-sm max-w-md py-1 px-3 rounded-md text-text font-semibold {{
        alertClasses()
      }} {{ className() }}">
      <fa-icon [icon]="icon()" class="{{ iconClasses() }}" />
      {{ message() }}
    </div>
  `,
  standalone: true,
  imports: [FontAwesomeModule],
})
export class DashboardAlertComponent {
  faInfo = faCircleInfo;
  faCheck = faCheck;
  faXmark = faXmark;

  private readonly _icons = {
    info: faCircleInfo,
    success: faCheck,
    error: faXmark,
    warning: faTriangleExclamation,
  };

  message = input<string>();
  type = input.required<AlertType>();
  className = input<string>();

  private readonly _alertClasses = {
    info: 'bg-blue-100',
    success: 'bg-green-100',
    error: 'bg-red-100',
    warning: 'bg-yellow-100',
  };

  private readonly _iconClasses = {
    info: 'text-primary',
    success: 'text-green-700',
    error: 'text-red-700',
    warning: 'text-yellow-700',
  };

  public icon = computed(() => {
    return this._icons[this.type()];
  });

  public alertClasses = computed(() => {
    return this._alertClasses[this.type()];
  });

  public iconClasses = computed(() => {
    return this._iconClasses[this.type()];
  });
}
